/**
 * Format a numeric value to a human-readable currency format
 * @param value - The numeric value to format
 * @param options - Formatting options
 * @returns Formatted string
 */
export function formatMoney(
    value: number,
    options: {
        /** Use abbreviated format (e.g., 1.5M instead of 1,500,000) */
        abbreviated?: boolean
        /** Show currency suffix (đ) */
        showCurrency?: boolean
        /** Locale for number formatting */
        locale?: string
        /** Maximum fraction digits */
        maximumFractionDigits?: number
    } = {}
): string {
    const {
        abbreviated = true,
        showCurrency = true,
        locale = 'vi-VN',
        maximumFractionDigits = 1,
    } = options

    const suffix = showCurrency ? 'đ' : ''

    if (abbreviated) {
        if (value >= 1_000_000_000) {
            const formatted = (value / 1_000_000_000).toLocaleString(locale, {
                maximumFractionDigits,
            })
            return `${formatted}B${suffix}`
        }
        if (value >= 1_000_000) {
            const formatted = (value / 1_000_000).toLocaleString(locale, {
                maximumFractionDigits,
            })
            return `${formatted}M${suffix}`
        }
        if (value >= 1_000) {
            const formatted = (value / 1_000).toLocaleString(locale, {
                maximumFractionDigits,
            })
            return `${formatted}K${suffix}`
        }
    }

    const formatted = value.toLocaleString(locale, { maximumFractionDigits: 0 })
    return `${formatted}${suffix}`
}

/**
 * Format a numeric value to full Vietnamese dong format (e.g., 100.000.000đ)
 * @param value - The numeric value to format
 * @returns Formatted string with VND currency
 */
export function formatVND(value: number): string {
    return value.toLocaleString('vi-VN') + 'đ'
}
